import { Component, Prop, Event, EventEmitter, h, forceUpdate } from '@stencil/core';
import { Color } from '../../interface';
import { createModal } from '../internal/modal/modal-controller';
import { ModalComponent } from '../internal/modal/modal-interface';
import { Trouble, Zone } from './area-interface';

@Component({
  tag: 'lar-area-content',
  styleUrl: 'area.scss',
  shadow: true,
})
export class AreaContent {
  @Prop() color?: Color;
  @Prop() colorModal?: Color;
  @Prop() zones: string;
  @Prop() troubles: string;
  @Prop() armed: boolean = false;
  @Prop() zoneopened: boolean = false;
  @Prop() hastroubles: boolean = false;
  @Prop() icon: string;
  @Prop() alarm: boolean = false;
  @Prop() loading: boolean = true;

  @Event() arm!: EventEmitter;
  @Event() disarm!: EventEmitter;
  @Event() output!: EventEmitter<any>;

  private modal?: HTMLLarModalElement;
  private modalComponent?: ModalComponent;

  private async showModal(title: string, subTitle: string, component: string) {
    this.modal = await createModal({
      mainTitle: title,
      subTitle,
      color: this.colorModal || this.color,
      animation: 'bottom',
      iconSmall: this.loading ? 'loading' : '',
      colorHeaderInputs: this.color,
      icon: this.icon,
      headerSize:'small',
      onLarmodaldiddismiss: () => {
        this.modal = undefined;
        this.modalComponent = undefined;
      },
      component,
      componentProps: {
        zones: this.zones,
        troubles: this.troubles,
        onOutput: (evt: CustomEvent) => this.output.emit(evt.detail),
        color: this.color,
      }
    });
    await this.modal.present();
    this.modalComponent = await this.modal.getComponent();
   }


  public async disconnectedCallback() {
    return this.modal?.dismiss();
  }

  render() {
    if (this.modalComponent) {
      this.modalComponent.element.setAttribute('zones', this.zones);
      this.modalComponent.element.setAttribute('troubles', this.troubles)
      this.modalComponent.element.setAttribute('color', this.color);
    }
    return [
      <div class="actions">
        {(this.armed || this.alarm)
          ?
          <lar-button
            onClick={() => this.disarm.emit()}
            color={this.color}
            disabled={this.loading}
          >
            <lar-icon icon="unlock" /> <lar-translate t="area.disarm"/>
          </lar-button>
          :
          <lar-button-group>
            <lar-button
              disabled={this.zoneopened || this.loading}
              onClick={() => this.hastroubles ? this.showModal('area.overrideAndBypass', 'area.selectZonesToBypass', 'lar-area-bypass'): this.arm.emit()}
              color={this.color}
            >
              <lar-icon icon="lock" /> <lar-translate t="area.arm"/>
            </lar-button>
            <lar-button
              disabled={this.loading}
              onClick={() => this.showModal('area.partialarm', 'area.selectZonesToBypass', 'lar-area-bypass')}
              color={this.color === 'dark' ? 'light' : 'dark'}
            >
              <lar-icon icon="halflock" /> <lar-translate t="area.partialarm"/>
            </lar-button>
          </lar-button-group>
        }
      </div>,
      <div class="details">
        <lar-button-group>
        {this.hastroubles
          &&
          <lar-button
            color="warning"
            size="small"
            expand="block"
            outline
            onClick={() => this.showModal('area.troubles', '', 'lar-area-troubles')}
          >
            <lar-icon icon="warning" />&nbsp;
            <lar-translate t="area.troubles" />
          </lar-button>
        }
        <lar-button
          color={this.color}
          size="small"
          expand="block"
          outline
          onClick={() => this.showModal('area.zonemonitor', '', 'lar-area-zones')}
        >
          <lar-translate t="area.zonemonitor" />&nbsp;
          {this.zoneopened
            ?
              <lar-icon icon="unlock" />
            :
              <lar-icon icon="lock" />
          }
        </lar-button>
        </lar-button-group>
      </div>
    ];
  }
}